import { render, staticRenderFns } from "./ContactType.vue?vue&type=template&id=e3934b86&"
import script from "./ContactType.vue?vue&type=script&lang=js&"
export * from "./ContactType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports